export const CHANGE_REQUEST_HIVE_BRANCH_PREFIX = 'cr';

/**
 * Returns true if the given branch is a change request.
 */
export function isChangeRequestBranchId(branchId: string): boolean {
    return branchId.startsWith('cr:');
}

/**
 * Parse a change request branch, extracting the ID of the change request.
 */
export function parseChangeRequestBranchId(branchId: string): string {
    const [prefix, changeRequestId] = branchId.split(':');
    if (prefix !== CHANGE_REQUEST_HIVE_BRANCH_PREFIX) {
        throw new Error(`Invalid change request branch ID: ${branchId}`);
    }
    return changeRequestId;
}

/**
 * Returns a Hive ContentBranch identifier given a ChangeRequest key.
 */
export function getChangeRequestBranchId(changeRequestKey: string): string {
    // TODO Use hive-core's formatBranchId. Currently importing hive-core breaks the tests.
    return `${CHANGE_REQUEST_HIVE_BRANCH_PREFIX}:${changeRequestKey}`;
}
